// utils/sendRichMessage.js
import socket from './socket';
/**
 * Sends a rich message via socket.
 * @param {string} dob - The date of birth string in dd/mm/yyyy format.
 * @param {object} reduxState - The Redux state object (i.e. state from useSelector or passed down).
 */
export const sendRichMessage = (dob, reduxState) => {
  const { engagement, user } = reduxState;

  console.log(engagement);

  const richMedia = {
    selectedAction: {
      type: 'reply',
      payload: dob,
    }
  };

  const body = {
    elementType: 'reply',
    elementText: {
      text: dob,
      textFormat: 'PLAINTEXT'
    },
    payload: dob,
    richMediaPayload: richMedia
  };

  const message = {
    body: body,
    senderName: user.user.displayName,
    providerDialogId: engagement.params.CustomerVerified === "true"
      ? (user.data.chProviderDialogId !== undefined
          ? user.user.chProviderDialogId
          : user.user.providerDialogId)
      : user.user.providerDialogId,
    providerSenderId: engagement.params.CustomerVerified === "true"
      ? (user.user.chProviderSenderId !== undefined
          ? user.user.chProviderSenderId
          : user.user.providerSenderId)
      : user.user.providerSenderId,
    engagementParam: user.user.engagementParameters,
    customerIdentifiers: user.user.customerIdentifiers,
  };

  const s = socket.getInstance();

  s.emit("message", message, (res) => {
    if (res.hasError) {
      console.error("Socket message error:", res);
    }
  });
};
